import { StateSnapshot } from 'react-virtuoso';
import { TPostDetail } from 'types';
import { create } from 'zustand';

type State = {
  bannerHeight?: number;
  postRecommendScrollY?: number;
  postFollowedScrollY?: number;
  listPostPaid: TPostDetail[];
  postRecommendVirtuosoState?: StateSnapshot | null;
  postFollowedVirtuosoState?: StateSnapshot | null;
};

type Actions = {
  setBannerHeight: (height: number) => void;
  setPostRecommendScrollY: (value?: number) => void;
  setPostFollowedScrollY: (value?: number) => void;
  setListPostPaid: (value: TPostDetail) => void;
  setRecommendVirtuosoState: (value?: StateSnapshot | null) => void;
  setFollowedVirtuosoState: (value?: StateSnapshot | null) => void;
};

const usePostStore = create<State & Actions>((set) => ({
  listPostPaid: [],
  postRecommendVirtuosoState: null,
  postFollowedVirtuosoState: null,
  setBannerHeight: (height: number) =>
    set(() => ({
      bannerHeight: height,
    })),
  setPostRecommendScrollY: (value?: number) => {
    set(() => ({ postRecommendScrollY: value }));
  },
  setPostFollowedScrollY: (value?: number) => {
    set(() => ({ postFollowedScrollY: value }));
  },
  setListPostPaid: (value: TPostDetail) => {
    set((state) => ({ listPostPaid: [...state.listPostPaid, value] }));
  },
  setRecommendVirtuosoState: (value) =>
    set({ postRecommendVirtuosoState: value ?? null }),
  setFollowedVirtuosoState: (value) =>
    set({ postFollowedVirtuosoState: value ?? null }),
}));

export default usePostStore;
